// extracted by mini-css-extract-plugin
module.exports = {"loaderContainer":"Loader_loaderContainer__24gdh","loader":"Loader_loader__1uQi3","loaderTxt":"Loader_loaderTxt__1SoOV","loaderIcon":"Loader_loaderIcon__k88FD"};